const axios = require('axios');

const readCookie = require('../readCookie');
const logger = require('../createLogger')('invokeS3Upload.js');

module.exports = async function() {
    logger.info('invoking s3_upload');

    const idToken = readCookie('id_token');
    if (!idToken) {
        logger.info('could not upload file since no user is signed in');
        return;
    }

    const authorizationValue = `Bearer ${idToken}`;

    const response = await axios({
        method: 'POST',
        url: `https://${process.env.VUE_APP_HOST_PUBLIC_API}/api/v1/s3/userfiles`,
        headers: {
            'Content-type': 'application/json',
            Authorization: authorizationValue,
        },
    });

    const { data } = response;

    if (!data) {
        logger.error('error when trying to upload file');
        return;
    }

    logger.info('sucessfully uploaded file');
    return data;
};
